import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import styles from '../SelectCategoryStep.scss';
import { assetsByCategory } from 'config/assets';

export const SelectCategoryStepGallery: FC = () => {
  const selectedCategory = useAppStore((state) => state.selectedCategory);
  const assets = assetsByCategory[selectedCategory];

  return (
    <div className={styles.selectCategoryStepGallery}>
      <div className={styles.selectCategoryStepGalleryContent}>
        {assets.slice(0, 3).map((asset) => (
          <div key={asset} className={styles.selectCategoryStepGalleryContentItem}>
            <img src={asset} alt={asset} />
          </div>
        ))}
      </div>
    </div>
  );
};
